import { useAppContext } from "hooks/useContext";
import type { ActiveVariantIdsType } from "@membership/constants";

export const useVariantIds = (): ActiveVariantIdsType => {
  const { variantIds } = useAppContext();
  return variantIds;
};
